import { faCubes } from "@fortawesome/pro-solid-svg-icons";
import { Chip } from "@mui/material";

import { Tooltip } from "@/components/ui-v2";
import { Icon } from "@/components/ui-v2/Icon/Icon";

import { ModelCardFragment } from "../../models.graphql";

interface ModelBaseModelIndicatorProps {
  model: ModelCardFragment;
}

export const ModelBaseModelIndicator = (
  props: ModelBaseModelIndicatorProps,
) => {
  const { model } = props;
  const { baseModelName } = model;

  if (!baseModelName) {
    return null;
  }

  return (
    <Tooltip
      title={`This model was finetuned on the base model ${baseModelName}.`}
    >
      <Chip
        label={
          <>
            <Icon icon={faCubes} data-testid="base-model-icon" />
            {" " + baseModelName}
          </>
        }
        variant="filled"
        size="small"
        sx={{
          color: "secondary.800",
        }}
      />
    </Tooltip>
  );
};
